import { CouponClass } from '@/types/we-coupons';
import { getClassList } from '@tencent/wphk-components-wecoupon/components/mch-coupon-list/api';

/**
 * 缓存分类列表
 */
let couponClassList: CouponClass[] = [];

/**
 * 获取券分类列表
 * @returns
 */
export async function getCouponClassList(): Promise<CouponClass[]> {
  const res: CouponClass[] = [];
  const { class_array: classArray = [] } = await getClassList();
  if (classArray && classArray.length > 0) {
    classArray.forEach((item) => {
      const { class_id: classId, class_name: className } = item;
      if (classId && className) {
        res.push({ classId, className });
      }
    });
  }
  couponClassList = res;
  return res;
}

/**
 * 获取当前分类的下一个分类
 * @param classId
 * @returns
 */
export function getNextCouponClass(classId: string): CouponClass | null {
  const classInfo = couponClassList.find(item => item.classId === classId);
  if (!classInfo) {
    return null;
  }
  return couponClassList[couponClassList.indexOf(classInfo) + 1] || null;
}
